"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mundrechtsanwaelteTheme = void 0;
exports.mundrechtsanwaelteTheme = {
    logos: {
        memoresaLogoName: "logo_bright.png",
        memoresaLogotypeName: "logotype_bright.png",
        themeLogoName: ["mundrechtsanwaelte.jpg"],
    },
    primary: {
        main: "#00739f",
    },
    secondary: {
        main: "#474747",
    },
    navbar: {
        bg: "#00739f",
        color: "#fff",
        hover: "#33a6d2",
    },
};
